import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import { Alert } from 'reactstrap';

import { LOGIN_PATH } from '../../utils/constants';
import renderInputField from '../formFields/Input';
import renderCheckBoxField from '../formFields/CheckBox';
import { validate, sanitazeMessage } from '../../utils/form';

import { PRIVACY_POLICY_URL, TERM_OF_USE_URL } from '../../app/config';

class SignupForm extends PureComponent {
  render() {
    const { handleSubmit, submitting, submitError, loggining } = this.props;

    return (
      <div className="auth-form login-form">
        <div className="error-wrapper">
          {submitError && (
            <Alert color="danger">
              {sanitazeMessage(submitError.message) ||
                'User with email or name already exists'}
            </Alert>
          )}
        </div>
        <form className="form" onSubmit={handleSubmit}>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Field
                name="name"
                component={renderInputField}
                type="text"
                placeholder="User Name"
              />
            </div>
          </div>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Field
                name="companyName"
                component={renderInputField}
                type="text"
                placeholder="Company Name"
              />
            </div>
          </div>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Field
                name="email"
                component={renderInputField}
                type="text"
                placeholder="Email"
              />
            </div>
          </div>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Field
                name="password"
                component={renderInputField}
                type="password"
                placeholder="Password"
              />
              <Field
                name="confirmPassword"
                component={renderInputField}
                type="password"
                validateOn="blur"
                className="second-field"
                placeholder="Confirm Password"
              />
            </div>
          </div>
          <div className="form__form-group confirmation-field">
            <div className="form__form-group-field">
              <Field
                name="confirmAgreement"
                className="colored"
                component={renderCheckBoxField}
                label={`I agree to the Start Magazine <a href=${TERM_OF_USE_URL} target=&quot;_blank&quot;>agreement</a>
                 and the <a href=${PRIVACY_POLICY_URL} target=&quot;_blank&quot;>Privacy policy</a>`}
              />
            </div>
          </div>
          <div className="block-centered">
            <button
              className="btn btn-primary account__btn account__btn--small"
              disabled={loggining || submitting}
              onClick={handleSubmit}
            >
              Sign Up
            </button>
          </div>
          <div className="full-width auth-link">
            Already have an account? <Link to={LOGIN_PATH}>Login here</Link>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'SignupForm',
  validate,
  touchOnBlur: false
})(SignupForm);



// WEBPACK FOOTER //
// ./src/components/signUp/SignupForm.js